import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { slideRight } from 'src/app/animations';

@Component({
  selector: 'app-about-project',
  templateUrl: './about-project.component.html',
  styleUrls: ['./about-project.component.scss'],
  animations: [
    slideRight
  ],
  host: {
    '[@slideRight]': 'condition'
 }
})
export class AboutProjectComponent implements OnInit {
  compId: string = '';
  projUid: string = '';
  @HostListener('@slideRight.done', ['$event']) doneDrawerHandler(event: any): void {
    this.projUid;
  }
  constructor(
    private route: ActivatedRoute,
  ) {
    this.compId = this.route.snapshot.params.id;
    this.projUid = this.route.snapshot.params.idp;
  }
  

  ngOnInit(): void {
  }

}
